import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorage } from '../helpers/localstorage.helper';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class loginGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const authToken = LocalStorage.get('auth');
    const refreshToken: any = LocalStorage.get('auth')?.refresh_token;
    let decoded: any = '';
    try {
      decoded = jwtDecode(refreshToken) as any;

    } catch (error) { }


    if (authToken && (new Date(decoded?.['exp'] * 1000).getTime() > new Date().getTime())) {
      this.router.navigate(['/']);
      return false;
    } else {
      return true;
    }
  }
}